const { VITE_PDT_DATASET_NAME, VITE_PDT_SCHEMA_TEMPLATE_ID } = import.meta.env;

export const PDT_CONSTANTS = {
  PDT_DATASET_NAME: VITE_PDT_DATASET_NAME,
  PDT_SCHEMA_TEMPLATE_ID: Number(VITE_PDT_SCHEMA_TEMPLATE_ID),
};
